<template>
  <v-text-field
    :label="value.caption"
    prepend-icon="mdi-account-circle"
    v-model="value.value"
    :readonly="readonly"
    :required="value == null ? false : value.required"
    :rules="rules"
    :name="value.name"
    :filled="filled"
  >
    <template #label>
      <span v-if="value.required" class="red--text"><strong>* </strong></span
      >{{ value.caption }}
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "MyFormUserName",
  props: {
    value: {
      type: Object,
      default: function() {
        return { name: "MyFormInputNotSet", value: "", caption: "not set" };
      },
    },
    readonly: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    filled: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  computed: {
    rules() {
      const rules = [];

      if (this.value.maxLength) {
        const rule = (v) =>
          (v || "").length <= this.value.maxLength ||
          this.$i18n.t("common.maximumcharactersallowed") +
            ": " +
            this.value.maxLength;

        rules.push(rule);
      }

      if (this.value.required) {
        const rule = (v) => !!v || this.$i18n.t("common.required");

        rules.push(rule);
      }
      return rules;
    },
  },
};
</script>

<style scoped></style>
